import { GetFutureContractsProps } from "@/services/future-contract.service";
import dayjs, { Dayjs } from "dayjs";
import {
  formatCurrencyInputToNumber,
  isEmpty,
  parseTonInputToNumber,
} from "@/utils/query-string";
import { Option } from "@/components/select/AsyncAutocompleteSelect";

export interface FCFRProps {
  future_contract_date?: Dayjs;
  account_number?: Option
  future_contract_amount: string;
  grain: number;
  ton: number;
  estados?: number[];
  tipoMoneda?: string;
}

export const getFutureContractsFilter = (
  event: FCFRProps,
): Partial<GetFutureContractsProps> => {
  let future_contract_amount: number | undefined;
  let tonValue: number | undefined;

  if (event?.future_contract_amount) {
    const num = formatCurrencyInputToNumber(event.future_contract_amount);

    if (!Number.isNaN(num)) {
      future_contract_amount = Number(num.toFixed(2));
    }
  }

  tonValue = parseTonInputToNumber(event?.ton);

  return {
    ...(event?.future_contract_date && dayjs(event?.future_contract_date).isValid()
      ? {
          fecha: dayjs(event?.future_contract_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
    ...(event?.account_number?.value
      ? {
          nroCuenta: String(event?.account_number?.value),
        }
      : {}),
    ...(event?.future_contract_amount && future_contract_amount
      ? {
          monto: future_contract_amount,
        }
      : {}),
    ...(isEmpty(tonValue)
      ? {}
      : {
          toneladas: tonValue,
        }),
    ...(event.grain
      ? {
          grano: event?.grain,
        }
      : {}),
    ...(event.tipoMoneda
      ? {
          tipoMoneda: event?.tipoMoneda,
        }
      : {}),
  };
};
